import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/es6.regexp.split";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import _throttle from "lodash/throttle";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component, createRef } from 'react';
import classNames from 'classnames';

var Ellipsis = /*#__PURE__*/function (_Component) {
  _inherits(Ellipsis, _Component);

  var _super = _createSuper(Ellipsis);

  function Ellipsis(props) {
    var _this;

    _classCallCheck(this, Ellipsis);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "containerRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      isPrepared: false
    });

    _defineProperty(_assertThisInitialized(_this), "ellipsize", function () {
      var element = _this.containerRef.current;
      var words = _this.props.children;
      var wordsArray = [];
      element.innerHTML = words;
      wordsArray = typeof words === 'string' && words.split(' ');
      /* istanbul ignore next */

      while (element.scrollHeight > element.offsetHeight && wordsArray.length > 0) {
        wordsArray.pop();
        element.innerHTML = "".concat(wordsArray.join(' '), "...");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.ellipsize();
    });

    _this.throttleHandleResize = _throttle(_this.handleResize, props.throttleWaitTime);
    return _this;
  }

  _createClass(Ellipsis, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.throttleHandleResize, {
        passive: true
      });
      this.ellipsize();
      this.setState({
        isPrepared: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.ellipsize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.throttleHandleResize, {
        passive: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          Tag = _this$props.tag,
          className = _this$props.className,
          throttleWaitTime = _this$props.throttleWaitTime,
          rest = _objectWithoutProperties(_this$props, ["children", "tag", "className", "throttleWaitTime"]);

      var isPrepared = this.state.isPrepared;
      var containerClassName = classNames('react-ellipsis_container', {
        reveal: isPrepared
      }, className);
      return /*#__PURE__*/React.createElement(Tag, Object.assign({
        ref: this.containerRef,
        className: containerClassName
      }, rest), children);
    }
  }]);

  return Ellipsis;
}(Component);

Ellipsis.defaultProps = {
  tag: 'p',
  throttleWaitTime: 250
};
export default Ellipsis;